import PromotionService from "../Services/PromotionService/PromotionService";
import EditorialService from "../Services/EditorialService/EditorialService";
import { notifUtils } from "../components/NotifUtils/NotifUtils";
import { handleError } from "../components/Utils/Utils";

export const getMall = (store, value, refresh) => {
  const isLoading = !store.state.isLoading;
  const status = 200;
  store.setState({ isLoading, status, refresh });
  EditorialService.getDataMall(value)
    .then((response) => {
      let data = response.data;
      const isLoading = false;
      const status = data.message;
      store.state.lastPage = false;
      store.state.data = refresh ? data : store.state.data.concat(data);
      if (data.length < parseInt(value.num)) {
        store.state.lastPage = true;
      }
      store.setState({
        isLoading,
        header: response.headers,
        status,
        refresh: false,
      });
    })
    .catch((error) => {
      handleError(error);
    });
};

export const getList = (store, value, prevTabActive) => {
  const isLoading = !store.state.isLoading;
  const status = 200;
  store.setState({ isLoading, status });
  PromotionService.getDataMall(value)
    .then((response) => {
      let data = response.data;
      const isLoading = false;
      const status = data.message;
      store.state.lastPage = false;
      store.state.data = prevTabActive ? store.state.data.concat(data) : data;
      if (data.length < parseInt(value.num)) {
        store.state.lastPage = true;
      }
      store.setState({
        isLoading,
        header: response.headers,
        status,
      });
    })
    .catch((error) => {
      handleError(error);
    });
};

export const storeMall = async (store, value) => {
  try {
    const response = await PromotionService.storeDataMall(value);
    const data = response.data;
    notifUtils("Successfully Created Promotion", "success");
    return data;
  } catch (error) {
    handleError(error);
    return error;
  }
};

export const putMall = async (store, id, params) => {
  try {
    const response = await PromotionService.putDataMall(id, params);
    const data = response.data;
    notifUtils("Successfully Update Promotion", "success");
    return data;
  } catch (error) {
    handleError(error);
    return error;
  }
};

export const deletedMall = async (store, id) => {
  try {
    await PromotionService.deleteMall(id);
    notifUtils("Successfully Remove Promotion", "success");
  } catch (error) {
    handleError(error);
    return error;
  }
};

export const patchMall = async (store, id, params, notif) => {
  try {
    const response = await PromotionService.patchMall(id, params);
    const data = response.data;
    notifUtils(notif, "success");
    return data;
  } catch (error) {
    handleError(error);
    return error;
  }
};

// promotion Tenant

export const getTenant = (store, value, refresh) => {
  const isLoading = !store.state.isLoading;
  const status = 200;
  store.setState({ isLoading, status, refresh });
  EditorialService.getDataTenant(value)
    .then((response) => {
      let data = response.data;
      const isLoading = false;
      const status = data.message;
      store.state.lastPage = false;
      store.state.data = refresh ? data : store.state.data.concat(data);
      if (data.length < parseInt(value.num)) {
        store.state.lastPage = true;
      }
      store.setState({
        isLoading,
        header: response.headers,
        status,
        refresh: false,
      });
    })
    .catch((error) => {
      handleError(error);
    });
};

export const storeTenant = async (store, value) => {
  try {
    const response = await PromotionService.storeDataTenant(value);
    const data = response.data;
    notifUtils("Successfully Created Promotion", "success");
    return data;
  } catch (error) {
    handleError(error);
    return error;
  }
};

export const putTenant = async (store, id, params) => {
  try {
    const response = await PromotionService.putDataTenant(id, params);
    const data = response.data;
    notifUtils("Successfully Update Promotion", "success");
    return data;
  } catch (error) {
    handleError(error);
    return error;
  }
};

export const deletedTenant = async (store, id) => {
  try {
    await PromotionService.deletedTenant(id);
    notifUtils("Successfully Remove Promotion", "success");
  } catch (error) {
    handleError(error);
    return error;
  }
};

export const approvedTenant = async (store, id, params) => {
  try {
    const response = await PromotionService.approvedTenant(id, params);
    const data = response.data;
    notifUtils("Successfully Update Promotion", "success");
    return data;
  } catch (error) {
    handleError(error);
    return error;
  }
};

export const patchTenant = async (store, id, params, notif) => {
  try {
    const response = await PromotionService.patchTenant(id, params);
    const data = response.data;
    notifUtils(notif, "success");
    return data;
  } catch (error) {
    handleError(error);
    return error;
  }
};
